import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { GlossarioService } from "src/app/services/glosssario.service";
import { obterGlossario, obterGlossarioFailure, obterGlossarioSuccess } from "../actions/glossario.action";
import { switchMap, map, catchError, of } from "rxjs";


@Injectable()
export class ObterGlossarioEffects {

  public obterGlossario$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly glossarioService: GlossarioService) {
    this.createEffects()
  }

  private createEffects() {
     this.obterGlossario$ = createEffect(() => this.actions$.pipe(
       ofType(obterGlossario),
       switchMap(() =>
         this.glossarioService
           .obterGlossario()
           .pipe(            
             map(              
               response => {
               if (response.erros != undefined && response.erros.length > 0) {
                 return obterGlossarioFailure({ response })
               }
               return obterGlossarioSuccess({ response })
             }),
             catchError(() => {
               return of()}
             )
           )
       )
     )
     );
   }
}